// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overall_header_panel {
    margin-left: 84px;
    margin-top: 50px;
    margin-right: 84px;
}

/* .logo {
    height: 30px;
    width: 45px;
    float: left;
    margin-right: 72px;
} */

.background_overlay {
    background-color: #000;
    opacity: 0.75;
}

.body {
    background-color: #f6f6f6;
}
.company_box {
    background-color: #fff;
    box-shadow: 2.661px 10.673px 32px 0px rgba(142, 142, 142, 0.21);
    margin-top: -350px;
    margin-left: 110px;
    margin-right: 10px;
    position: absolute;
    top: 155px;
    width: 1300px;
    height: 700px;
    padding: 50px;
}
.company_image {
    float: left;
    width: 246px;
    height: 174px;
    box-shadow: 2.661px 10.673px 32px 0px rgba(2, 2, 2, 0.21);
    margin-right: 37px;
}

.back_to_search_icon {
    height: 10px;
    width: 14px;
    padding-right: 9px;
    float: left;
}
.back_to_search_text {
    font-size: 14px;
    font-weight: regular;
    color: #394350;
    padding-bottom: 35px;
}
.seller_header {
    font-size: 21px;
    color: #333;
    font-weight: bold;
    padding-bottom: 18px;
}
.location_icon {
    width: 12px;
    height: 16px;
}
.seller_location {
    font-size: 16px;
    color: #666666;
    font-weight: medium;
    padding-bottom: 32px;
    padding-left: 10px;
}
.get_info_button {
    background-color: #202425;
    width: 144px;
    height: 32px;
    font-size: 13px;
    text-transform: uppercase;
    color: #fff;
    text-align: center;
    font-weight: medium;
    margin-bottom: 65px;
}
.selling_details_title {
    color: #1c2b69;
    font-size: 16px;
    font-weight: medium;
    padding-top: 30px;
    padding-bottom: 20px;
    text-align: left;
}
.selling_price_text {
    color: #000;
    font-size: 14px;
    font-weight: regular;
    padding-bottom: 10px;
    /* padding-right: 40px;  */
    text-align: left;
}
.selling_price_number {
    color: #000;
    font-size: 15px;
    font-weight: medium;
    padding-bottom: 22.5px;
    text-align: left;
}
.business_info_title {
    color: #1c2b69;
    font-size: 16px;
    font-weight: medium;
    padding-bottom: 60;
    text-align: left;
}
.year_established_text {
    color: #000;
    font-size: 14px;
    font-weight: regular;
    padding-bottom: 10px;
    margin-left: 10;
    text-align: left;
}
.year_established_number {
    color: #000;
    font-size: 15px;
    font-weight: medium;
    padding-bottom: 22.5px;
    text-align: left;
}
.pdf_icon {
    width: 16px;
    height: 17px;
    padding-right: 8px;
}
.similar_business_area {
    height: 204px;
    width: 100%;
    margin-left: 34px;
    margin-right: 34px;
    margin-top: 850px;
    margin-bottom: 50px;
}
.similar_business_title {
    font-size: 16px;
    color: #394350;
    font-weight: medium;
    padding-bottom: 26px;
    text-align: left;
}
.company_content {
    background-color: #fff;
    box-shadow: 2.661px 10.673px 32px 0px rgba(142, 142, 142, 0.21);
    width: 270px;
    height: 105px;
    margin-right: 42px;
    padding: 20px 17px;
}
.company_initial_box {
    background-color: #de7979;
    box-shadow: 2.661px 10.673px 32px 0px rgba(142, 142, 142, 0.21);
    width: 58.5px;
    height: 65.5px;
    font-size: 35px;
    font-weight: medium;
    text-align: center;
    color: #fff;
}
.company_header {
    font-size: 17px;
    color: #000;
    font-weight: medium;
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 26px;
}
.location_icon {
    padding-left: 26px;
    height: 16px;
    width: 12px;
}
.company_location {
    font-size: 13px;
    color: #666666;
    font-weight: medium;
    padding-bottom: 12px;
    padding-left: 10px;
}
.scroll_right_arrow {
    float: right;
    background-image: -ms-linear-gradient(
        0deg,
        rgb(241, 241, 241) 0%,
        rgba(241, 241, 241, 0.47) 47%,
        rgb(246, 246, 246) 100%
    );
    width: 153px;
    height: 169px;
    vertical-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/css/pages/company/companyView.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;;;;GAKG;;AAEH;IACI,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,sBAAsB;IACtB,+DAA+D;IAC/D,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,aAAa;IACb,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yDAAyD;IACzD,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,eAAe;IACf,oBAAoB;IACpB,cAAc;IACd,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,oBAAoB;IACpB,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,+DAA+D;IAC/D,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,+DAA+D;IAC/D,aAAa;IACb,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;AACA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,YAAY;IAaZ;;;;;KAKC;IACD,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B","sourcesContent":[".overall_header_panel {\n    margin-left: 84px;\n    margin-top: 50px;\n    margin-right: 84px;\n}\n\n/* .logo {\n    height: 30px;\n    width: 45px;\n    float: left;\n    margin-right: 72px;\n} */\n\n.background_overlay {\n    background-color: #000;\n    opacity: 0.75;\n}\n\n.body {\n    background-color: #f6f6f6;\n}\n.company_box {\n    background-color: #fff;\n    box-shadow: 2.661px 10.673px 32px 0px rgba(142, 142, 142, 0.21);\n    margin-top: -350px;\n    margin-left: 110px;\n    margin-right: 10px;\n    position: absolute;\n    top: 155px;\n    width: 1300px;\n    height: 700px;\n    padding: 50px;\n}\n.company_image {\n    float: left;\n    width: 246px;\n    height: 174px;\n    box-shadow: 2.661px 10.673px 32px 0px rgba(2, 2, 2, 0.21);\n    margin-right: 37px;\n}\n\n.back_to_search_icon {\n    height: 10px;\n    width: 14px;\n    padding-right: 9px;\n    float: left;\n}\n.back_to_search_text {\n    font-size: 14px;\n    font-weight: regular;\n    color: #394350;\n    padding-bottom: 35px;\n}\n.seller_header {\n    font-size: 21px;\n    color: #333;\n    font-weight: bold;\n    padding-bottom: 18px;\n}\n.location_icon {\n    width: 12px;\n    height: 16px;\n}\n.seller_location {\n    font-size: 16px;\n    color: #666666;\n    font-weight: medium;\n    padding-bottom: 32px;\n    padding-left: 10px;\n}\n.get_info_button {\n    background-color: #202425;\n    width: 144px;\n    height: 32px;\n    font-size: 13px;\n    text-transform: uppercase;\n    color: #fff;\n    text-align: center;\n    font-weight: medium;\n    margin-bottom: 65px;\n}\n.selling_details_title {\n    color: #1c2b69;\n    font-size: 16px;\n    font-weight: medium;\n    padding-top: 30px;\n    padding-bottom: 20px;\n    text-align: left;\n}\n.selling_price_text {\n    color: #000;\n    font-size: 14px;\n    font-weight: regular;\n    padding-bottom: 10px;\n    /* padding-right: 40px;  */\n    text-align: left;\n}\n.selling_price_number {\n    color: #000;\n    font-size: 15px;\n    font-weight: medium;\n    padding-bottom: 22.5px;\n    text-align: left;\n}\n.business_info_title {\n    color: #1c2b69;\n    font-size: 16px;\n    font-weight: medium;\n    padding-bottom: 60;\n    text-align: left;\n}\n.year_established_text {\n    color: #000;\n    font-size: 14px;\n    font-weight: regular;\n    padding-bottom: 10px;\n    margin-left: 10;\n    text-align: left;\n}\n.year_established_number {\n    color: #000;\n    font-size: 15px;\n    font-weight: medium;\n    padding-bottom: 22.5px;\n    text-align: left;\n}\n.pdf_icon {\n    width: 16px;\n    height: 17px;\n    padding-right: 8px;\n}\n.similar_business_area {\n    height: 204px;\n    width: 100%;\n    margin-left: 34px;\n    margin-right: 34px;\n    margin-top: 850px;\n    margin-bottom: 50px;\n}\n.similar_business_title {\n    font-size: 16px;\n    color: #394350;\n    font-weight: medium;\n    padding-bottom: 26px;\n    text-align: left;\n}\n.company_content {\n    background-color: #fff;\n    box-shadow: 2.661px 10.673px 32px 0px rgba(142, 142, 142, 0.21);\n    width: 270px;\n    height: 105px;\n    margin-right: 42px;\n    padding: 20px 17px;\n}\n.company_initial_box {\n    background-color: #de7979;\n    box-shadow: 2.661px 10.673px 32px 0px rgba(142, 142, 142, 0.21);\n    width: 58.5px;\n    height: 65.5px;\n    font-size: 35px;\n    font-weight: medium;\n    text-align: center;\n    color: #fff;\n}\n.company_header {\n    font-size: 17px;\n    color: #000;\n    font-weight: medium;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    padding-left: 26px;\n}\n.location_icon {\n    padding-left: 26px;\n    height: 16px;\n    width: 12px;\n}\n.company_location {\n    font-size: 13px;\n    color: #666666;\n    font-weight: medium;\n    padding-bottom: 12px;\n    padding-left: 10px;\n}\n.scroll_right_arrow {\n    float: right;\n    background-image: -moz-linear-gradient(\n        0deg,\n        rgb(241, 241, 241) 0%,\n        rgba(241, 241, 241, 0.47) 47%,\n        rgb(246, 246, 246) 100%\n    );\n    background-image: -webkit-linear-gradient(\n        0deg,\n        rgb(241, 241, 241) 0%,\n        rgba(241, 241, 241, 0.47) 47%,\n        rgb(246, 246, 246) 100%\n    );\n    background-image: -ms-linear-gradient(\n        0deg,\n        rgb(241, 241, 241) 0%,\n        rgba(241, 241, 241, 0.47) 47%,\n        rgb(246, 246, 246) 100%\n    );\n    width: 153px;\n    height: 169px;\n    vertical-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
